import { BrowserRouter, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Main from "./pages/Main";
import FusionCriteria from "./pages/FusionCriteria";
import HackCriteria from "./pages/HackCriteria";
import PolicyCriteria from "./pages/PolicyCriteria";
import GeneralInformation from "./pages/GeneralInformation";
import MentorInstructions from "./pages/MentorInstructions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Route path="/" exact component={Homepage} />
        <Route path="/schedule" component={Main} />
        <Route path="/criteria/hack" component={HackCriteria} />
        <Route path="/criteria/policy" component={PolicyCriteria} />
        <Route path="/criteria/fusion" component={FusionCriteria} />
        <Route path="/general-information" component={GeneralInformation} />
        <Route path="/mentors" component={MentorInstructions} />
      </BrowserRouter>
    </div>
  );
}

export default App;
